import { createModalExecutor } from '@organisms/actions/createModalExecutor';
import { IEditAttachProps } from './IEditAttachProps';
import { EditAttachModal } from './EditAttachModal';

export const EditExecutor = createModalExecutor<IEditAttachProps>({
    modal: EditAttachModal,
    defaultModalSize: 'm',
    emptyElement: <div />,
    mapProps: ({ objId, parentId, action, rowData, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: parentId ?? '',
        attachId: objId,
        rowData: rowData,
        options: action.options,
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
